import React from 'react';
import { HeaderContent } from 'site-modules/personalized-search/components/header-content/header-content';

export function AnchorItem(props) {
  return (
    <>
      <HeaderContent {...props} withAnchorLink />
      <hr />
    </>
  );
}
